import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA4 from 'react-ga4';

// Initialize Google Analytics with your measurement ID
ReactGA4.initialize('G-0PSD70ZZD3');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Send pageview when the app loads
ReactGA4.send({ hitType: "pageview", page: window.location.pathname + window.location.search });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(({ id, name, value }) => {
  // Optional: Send web vitals data to Google Analytics
  ReactGA4.event({
    category: 'Web Vitals',
    action: name,
    label: id,
    value: Math.round(value),
    nonInteraction: true,
  });
});